import React from 'react'
import { useAppSelector } from '../../../hooks/redux'
import { useQueueState } from '../../../providers/QueueStateProvider'
import { selectConvo } from '../../../slices/convo'
import useStyles from './styles'

interface ChatContainerProps {
  children?: React.ReactNode
}
const ChatContainer: React.FC<ChatContainerProps> = ({ children }) => {
  const { conversation } = useQueueState()
  const { hideEngagementHub } = useAppSelector(selectConvo)

  const classes = useStyles({
    conversationSelected: Boolean(conversation),
    hideEngagementHub
  })

  return <div className={classes.root}>{children}</div>
}

export default ChatContainer
